import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import 'jquery';
global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

// CSS — ordine importante: BS5 → design-system (override) → custom → personalizzazioni
import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/css/design-system.css"
import "./assets/css/custom.css"
import "./assets/css/personalizzazioni.css"
import "./assets/css/css-loader.css"
import "./assets/css/loader-default.css"
import "./assets/css/bootstrap-datepicker3.standalone.min.css"
import "./assets/css/notify.min.css"
import "./assets/css/select2.min.css"
import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.min.css';
import "./assets/css/FA_ORIG/css/all.min.css"

// Bootstrap 5 JS — esposto globalmente per il jQuery modal shim
import * as bootstrap from 'bootstrap';
global.bootstrap = bootstrap;
window.bootstrap = bootstrap;

import "./assets/js/select2.min.js"
import utils from "./assets/js/utils.js"
import filters from "./assets/js/filters.js"
import moment from 'moment';
import "bootstrap-datepicker";

// Generato da claude — jQuery modal shim per BS5:
// Rende compatibili le 43 chiamate esistenti $(...).modal('show'/'hide') senza toccarle
$.fn.modal = function(action) {
    const el = this[0];
    if (!el) return this;
    const m = bootstrap.Modal.getOrCreateInstance(el);
    if (action === 'show') m.show();
    else if (action === 'hide') m.hide();
    else if (action === 'toggle') m.toggle();
    else if (action === 'dispose') m.dispose();
    return this;
};

// Generato da claude — shim per data-dismiss="modal" (BS4) su click
$(document).on('click', '[data-dismiss="modal"]', function() {
    const modalEl = $(this).closest('.modal')[0];
    if (modalEl) bootstrap.Modal.getInstance(modalEl)?.hide();
});

// Generato da claude — shim per data-dismiss="toast" (BS4) su click
$(document).on('click', '[data-dismiss="toast"]', function() {
    const toastEl = $(this).closest('.toast')[0];
    if (!toastEl) return;
    const t = bootstrap.Toast.getInstance(toastEl);
    if (t) {
        t.hide();
    } else {
        $(toastEl).removeClass('show').addClass('hide');
        setTimeout(() => $(toastEl).remove(), 300);
    }
});

global.router = router;
global.utils = utils.utils;
global.filters = filters.filters;
global.moment = moment;

global.sprint = createApp(App).use(router)
global.sprint.config.devtools = true
global.sprint.mount('#app');

$(function(){
    // Lingua italiana per bootstrap-datepicker
    !function(a){a.fn.datepicker.dates.it={days:["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"],daysShort:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"],daysMin:["Do","Lu","Ma","Me","Gi","Ve","Sa"],months:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],monthsShort:["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],today:"Oggi",monthsTitle:"Mesi",clear:"Cancella",weekStart:1,format:"dd/mm/yyyy"}}(global.jQuery);
    $.fn.datepicker.defaults.language = 'it';
});

global.utils.createLoader();

$(function(){
    global.utils.resizeContent();
    $(window).resize(function(){
        global.utils.resizeContent();
    });
    global.$('html').click(function(e) {
        if (global.utils.navIsOpen == true && e.target.id != 'mySidenav' && e.target.className != 'sidenav' && e.target.className != 'select2-selection__choice__remove' && $(e.target).parents('.sidenav').length == 0) {
            global.utils.closeNav();
        }
    });
});
